import styled, {css} from 'styled-components'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

export const StyledContainerCard = styled(Flexbox)`
    ${({theme}) => css`
        border: 1px solid ${theme.palette.neutral['200']};
        border-radius: 16px;
        padding: ${theme.spacing * 4}px ${theme.spacing * 5}px;
        margin-bottom: ${theme.spacing * 2}px;
    `}
`

export const StyledCardRow = styled.div`
    ${({theme}) => css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: ${theme.spacing * 8}px;
        width: 100%;

        > div:last-child {
            &[data-highlight='true'] {
                grid-column: 1 / -1;
            }
        }

        @media (max-width: 768px) {
            gap: ${theme.spacing * 4}px;
        }
    `}
`

export const StyledCardActions = styled(Flexbox)`
    ${({theme}) => css`
        padding: ${theme.spacing * 4}px 0;
    `}
`

export const StyledCardInfo = styled.span`
    ${({theme}) => css`
        ${theme.typography.textSm};
        font-weight: 500;
        color: ${theme.palette.neutral[900]};
        text-transform: capitalize;
        word-break: break-word;
    `}
`

export const StyledCardInfoHeader = styled.span`
    ${({theme}) => css`
        ${theme.typography.textXs};
        font-weight: 500;
        color: ${theme.palette.neutral[500]};
        break-after: auto;
    `}
`

export const StyledCardLink = styled.a`
    ${({theme}) => css`
        ${theme.typography.textSm};
        font-weight: 500;
        color: ${theme.palette.primary[800]};
        text-decoration: underline;
        break-after: auto;
    `}
`
export const SkeletonChip = styled(Skeleton)`
    width: 24px;
    height: 24px;
    border-radius: 4px;
`

export const SkeletonText = styled(Skeleton)`
    height: 20px;
    width: 100%;
`

export const StyledBlurredContent = styled.div<{$isBlurred: boolean}>`
    filter: ${({$isBlurred}) => ($isBlurred ? 'blur(4px)' : 'none')};
    transition: filter 0.2s ease-in-out;
    user-select: ${({$isBlurred}) => ($isBlurred ? 'none' : 'auto')};
`
